var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-form", { staticClass: "result-form" }, [
    _c("table", { attrs: { cellpadding: "0", cellspacing: "0" } }, [
      _c("tr", [
        _c("td", { staticClass: "header" }, [
          _vm._v(_vm._s(_vm.$t("FileHistory.fileName")))
        ]),
        _c("td", { attrs: { colspan: "3" } }, [
          _c("span", { staticStyle: { "margin-left": "10px" } }, [
            _vm._v(_vm._s(_vm.details.fileName))
          ])
        ])
      ]),
      _c("tr", [
        _c("td", { staticClass: "header" }, [
          _vm._v(_vm._s(_vm.$t("SeaExport.SerialNo")))
        ]),
        _c("td", [
          _c("span", { staticStyle: { "margin-left": "10px" } }, [
            _vm._v(_vm._s(_vm.details.fileNo))
          ])
        ]),
        _c("td", { staticClass: "header" }, [
          _vm._v(_vm._s(_vm.$t("SeaExport.BusinessNumber")))
        ]),
        _c("td", [
          _c("span", { staticStyle: { "margin-left": "10px" } }, [
            _vm._v(_vm._s(_vm.details.jobNo))
          ])
        ])
      ]),
      _c("tr", [
        _c("td", { staticClass: "header", attrs: { rowspan: "7" } }, [
          _vm._v(_vm._s(_vm.$t("Message.Shipper")))
        ]),
        _c(
          "td",
          [
            _c(
              "el-form-item",
              [
                _c("el-input", {
                  on: {
                    focus: function($event) {
                      return _vm.handleFocus("shipper")
                    }
                  },
                  model: {
                    value: _vm.resultJson.shipper.value1,
                    callback: function($$v) {
                      _vm.$set(_vm.resultJson.shipper, "value1", $$v)
                    },
                    expression: "resultJson.shipper.value1"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c("td", { staticClass: "header" }, [
          _vm._v(_vm._s(_vm.$t("SeaExport.BLForm")))
        ]),
        _c(
          "td",
          [
            _c(
              "el-form-item",
              [
                _c("el-input", {
                  on: {
                    focus: function($event) {
                      return _vm.handleFocus("orderType")
                    }
                  },
                  model: {
                    value: _vm.resultJson.orderType.value,
                    callback: function($$v) {
                      _vm.$set(_vm.resultJson.orderType, "value", $$v)
                    },
                    expression: "resultJson.orderType.value"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("tr", [
        _c(
          "td",
          [
            _c(
              "el-form-item",
              [
                _c("el-input", {
                  on: {
                    focus: function($event) {
                      return _vm.handleFocus("shipper")
                    }
                  },
                  model: {
                    value: _vm.resultJson.shipper.value2,
                    callback: function($$v) {
                      _vm.$set(_vm.resultJson.shipper, "value2", $$v)
                    },
                    expression: "resultJson.shipper.value2"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c("td", { staticClass: "header" }, [
          _vm._v(_vm._s(_vm.$t("SeaExport.LCL")))
        ]),
        _c(
          "td",
          [
            _c(
              "el-form-item",
              [
                _c("el-input", {
                  on: {
                    focus: function($event) {
                      return _vm.handleFocus("fclOrLcl")
                    }
                  },
                  model: {
                    value: _vm.resultJson.fclOrLcl.value,
                    callback: function($$v) {
                      _vm.$set(_vm.resultJson.fclOrLcl, "value", $$v)
                    },
                    expression: "resultJson.fclOrLcl.value"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("tr", [
        _c(
          "td",
          [
            _c(
              "el-form-item",
              [
                _c("el-input", {
                  on: {
                    focus: function($event) {
                      return _vm.handleFocus("shipper")
                    }
                  },
                  model: {
                    value: _vm.resultJson.shipper.value3,
                    callback: function($$v) {
                      _vm.$set(_vm.resultJson.shipper, "value3", $$v)
                    },
                    expression: "resultJson.shipper.value3"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c("td", { staticClass: "header" }, [
          _vm._v(_vm._s(_vm.$t("SeaExport.ShippingCompany")))
        ]),
        _c(
          "td",
          [
            _c(
              "el-form-item",
              [
                _c("el-input", {
                  on: {
                    focus: function($event) {
                      return _vm.handleFocus("shipName")
                    }
                  },
                  model: {
                    value: _vm.resultJson.shipName.value,
                    callback: function($$v) {
                      _vm.$set(_vm.resultJson.shipName, "value", $$v)
                    },
                    expression: "resultJson.shipName.value"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("tr", [
        _c(
          "td",
          [
            _c(
              "el-form-item",
              [
                _c("el-input", {
                  on: {
                    focus: function($event) {
                      return _vm.handleFocus("shipper")
                    }
                  },
                  model: {
                    value: _vm.resultJson.shipper.value4,
                    callback: function($$v) {
                      _vm.$set(_vm.resultJson.shipper, "value4", $$v)
                    },
                    expression: "resultJson.shipper.value4"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c("td", { staticClass: "header" }, [
          _vm._v(_vm._s(_vm.$t("Payment.vessel")))
        ]),
        _c(
          "td",
          [
            _c(
              "el-form-item",
              [
                _c("el-input", {
                  on: {
                    focus: function($event) {
                      return _vm.handleFocus("vessel")
                    }
                  },
                  model: {
                    value: _vm.resultJson.vessel.value,
                    callback: function($$v) {
                      _vm.$set(_vm.resultJson.vessel, "value", $$v)
                    },
                    expression: "resultJson.vessel.value"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("tr", [
        _c(
          "td",
          [
            _c(
              "el-form-item",
              [
                _c("el-input", {
                  on: {
                    focus: function($event) {
                      return _vm.handleFocus("shipper")
                    }
                  },
                  model: {
                    value: _vm.resultJson.shipper.value5,
                    callback: function($$v) {
                      _vm.$set(_vm.resultJson.shipper, "value5", $$v)
                    },
                    expression: "resultJson.shipper.value5"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c("td", { staticClass: "header" }, [
          _vm._v(_vm._s(_vm.$t("Payment.voyage")))
        ]),
        _c(
          "td",
          [
            _c(
              "el-form-item",
              [
                _c("el-input", {
                  on: {
                    focus: function($event) {
                      return _vm.handleFocus("voyage")
                    }
                  },
                  model: {
                    value: _vm.resultJson.voyage.value,
                    callback: function($$v) {
                      _vm.$set(_vm.resultJson.voyage, "value", $$v)
                    },
                    expression: "resultJson.voyage.value"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("tr", [
        _c(
          "td",
          [
            _c(
              "el-form-item",
              [
                _c("el-input", {
                  on: {
                    focus: function($event) {
                      return _vm.handleFocus("shipper")
                    }
                  },
                  model: {
                    value: _vm.resultJson.shipper.value6,
                    callback: function($$v) {
                      _vm.$set(_vm.resultJson.shipper, "value6", $$v)
                    },
                    expression: "resultJson.shipper.value6"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c("td", { staticClass: "header" }, [
          _vm._v(_vm._s(_vm.$t("queryJob.dateOfDeparture")))
        ]),
        _c(
          "td",
          [
            _c(
              "el-form-item",
              [
                _c("el-input", {
                  on: {
                    focus: function($event) {
                      return _vm.handleFocus("etd")
                    }
                  },
                  model: {
                    value: _vm.resultJson.etd.value,
                    callback: function($$v) {
                      _vm.$set(_vm.resultJson.etd, "value", $$v)
                    },
                    expression: "resultJson.etd.value"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("tr", [
        _c(
          "td",
          [
            _c(
              "el-form-item",
              [
                _c("el-input", {
                  on: {
                    focus: function($event) {
                      return _vm.handleFocus("shipper")
                    }
                  },
                  model: {
                    value: _vm.resultJson.shipper.value7,
                    callback: function($$v) {
                      _vm.$set(_vm.resultJson.shipper, "value7", $$v)
                    },
                    expression: "resultJson.shipper.value7"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c("td", { attrs: { colspan: "2" } })
      ]),
      _c("tr", [
        _c("td", { staticClass: "header", attrs: { rowspan: "7" } }, [
          _vm._v(_vm._s(_vm.$t("Message.Consignee")))
        ]),
        _c(
          "td",
          [
            _c(
              "el-form-item",
              [
                _c("el-input", {
                  on: {
                    focus: function($event) {
                      return _vm.handleFocus("consignee")
                    }
                  },
                  model: {
                    value: _vm.resultJson.consignee.value1,
                    callback: function($$v) {
                      _vm.$set(_vm.resultJson.consignee, "value1", $$v)
                    },
                    expression: "resultJson.consignee.value1"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c("td", { staticClass: "header" }, [
          _vm._v(_vm._s(_vm.$t("SeaExport.TransportationClause")))
        ]),
        _c(
          "td",
          [
            _c(
              "el-form-item",
              [
                _c("el-input", {
                  on: {
                    focus: function($event) {
                      return _vm.handleFocus("serviceTerm")
                    }
                  },
                  model: {
                    value: _vm.resultJson.serviceTerm.value,
                    callback: function($$v) {
                      _vm.$set(_vm.resultJson.serviceTerm, "value", $$v)
                    },
                    expression: "resultJson.serviceTerm.value"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("tr", [
        _c(
          "td",
          [
            _c(
              "el-form-item",
              [
                _c("el-input", {
                  on: {
                    focus: function($event) {
                      return _vm.handleFocus("consignee")
                    }
                  },
                  model: {
                    value: _vm.resultJson.consignee.value2,
                    callback: function($$v) {
                      _vm.$set(_vm.resultJson.consignee, "value2", $$v)
                    },
                    expression: "resultJson.consignee.value2"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c("td", { staticClass: "header" }, [
          _vm._v(_vm._s(_vm.$t("SeaExport.FreightTerm")))
        ]),
        _c(
          "td",
          [
            _c(
              "el-form-item",
              [
                _c("el-input", {
                  on: {
                    focus: function($event) {
                      return _vm.handleFocus("paymenTerm")
                    }
                  },
                  model: {
                    value: _vm.resultJson.paymenTerm.value,
                    callback: function($$v) {
                      _vm.$set(_vm.resultJson.paymenTerm, "value", $$v)
                    },
                    expression: "resultJson.paymenTerm.value"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("tr", [
        _c(
          "td",
          [
            _c(
              "el-form-item",
              [
                _c("el-input", {
                  on: {
                    focus: function($event) {
                      return _vm.handleFocus("consignee")
                    }
                  },
                  model: {
                    value: _vm.resultJson.consignee.value3,
                    callback: function($$v) {
                      _vm.$set(_vm.resultJson.consignee, "value3", $$v)
                    },
                    expression: "resultJson.consignee.value3"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c("td", { staticClass: "header" }, [
          _vm._v(_vm._s(_vm.$t("SeaExport.ContainerSize")))
        ]),
        _c(
          "td",
          [
            _c(
              "el-form-item",
              [
                _c("el-input", {
                  on: {
                    focus: function($event) {
                      return _vm.handleFocus("boxType")
                    }
                  },
                  model: {
                    value: _vm.resultJson.boxType.value,
                    callback: function($$v) {
                      _vm.$set(_vm.resultJson.boxType, "value", $$v)
                    },
                    expression: "resultJson.boxType.value"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("tr", [
        _c(
          "td",
          [
            _c(
              "el-form-item",
              [
                _c("el-input", {
                  on: {
                    focus: function($event) {
                      return _vm.handleFocus("consignee")
                    }
                  },
                  model: {
                    value: _vm.resultJson.consignee.value4,
                    callback: function($$v) {
                      _vm.$set(_vm.resultJson.consignee, "value4", $$v)
                    },
                    expression: "resultJson.consignee.value4"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c("td", { staticClass: "header" }, [
          _vm._v(_vm._s(_vm.$t("SeaExport.ContainerAmount")))
        ]),
        _c(
          "td",
          [
            _c(
              "el-form-item",
              [
                _c("el-input", {
                  on: {
                    focus: function($event) {
                      return _vm.handleFocus("boxVolume")
                    }
                  },
                  model: {
                    value: _vm.resultJson.boxVolume.value,
                    callback: function($$v) {
                      _vm.$set(_vm.resultJson.boxVolume, "value", $$v)
                    },
                    expression: "resultJson.boxVolume.value"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("tr", [
        _c(
          "td",
          [
            _c(
              "el-form-item",
              [
                _c("el-input", {
                  on: {
                    focus: function($event) {
                      return _vm.handleFocus("consignee")
                    }
                  },
                  model: {
                    value: _vm.resultJson.consignee.value5,
                    callback: function($$v) {
                      _vm.$set(_vm.resultJson.consignee, "value5", $$v)
                    },
                    expression: "resultJson.consignee.value5"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c("td", { staticClass: "header" }, [
          _vm._v(_vm._s(_vm.$t("queryJob.IncoTerm")))
        ]),
        _c(
          "td",
          [
            _c(
              "el-form-item",
              [
                _c("el-input", {
                  on: {
                    focus: function($event) {
                      return _vm.handleFocus("deliveryTerm")
                    }
                  },
                  model: {
                    value: _vm.resultJson.deliveryTerm.value,
                    callback: function($$v) {
                      _vm.$set(_vm.resultJson.deliveryTerm, "value", $$v)
                    },
                    expression: "resultJson.deliveryTerm.value"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("tr", [
        _c(
          "td",
          [
            _c(
              "el-form-item",
              [
                _c("el-input", {
                  on: {
                    focus: function($event) {
                      return _vm.handleFocus("consignee")
                    }
                  },
                  model: {
                    value: _vm.resultJson.consignee.value6,
                    callback: function($$v) {
                      _vm.$set(_vm.resultJson.consignee, "value6", $$v)
                    },
                    expression: "resultJson.consignee.value6"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c("td", { staticClass: "header" }, [
          _vm._v(_vm._s(_vm.$t("Payment.contactPerson")))
        ]),
        _c(
          "td",
          [
            _c(
              "el-form-item",
              [
                _c("el-input", {
                  on: {
                    focus: function($event) {
                      return _vm.handleFocus("contacts")
                    }
                  },
                  model: {
                    value: _vm.resultJson.contacts.value,
                    callback: function($$v) {
                      _vm.$set(_vm.resultJson.contacts, "value", $$v)
                    },
                    expression: "resultJson.contacts.value"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("tr", [
        _c(
          "td",
          [
            _c(
              "el-form-item",
              [
                _c("el-input", {
                  on: {
                    focus: function($event) {
                      return _vm.handleFocus("consignee")
                    }
                  },
                  model: {
                    value: _vm.resultJson.consignee.value7,
                    callback: function($$v) {
                      _vm.$set(_vm.resultJson.consignee, "value7", $$v)
                    },
                    expression: "resultJson.consignee.value7"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c("td", { attrs: { colspan: "2" } })
      ]),
      _c("tr", [
        _c("td", { staticClass: "header", attrs: { rowspan: "7" } }, [
          _vm._v(_vm._s(_vm.$t("Message.Notify")))
        ]),
        _c(
          "td",
          [
            _c(
              "el-form-item",
              [
                _c("el-input", {
                  on: {
                    focus: function($event) {
                      return _vm.handleFocus("notifyParty")
                    }
                  },
                  model: {
                    value: _vm.resultJson.notifyParty.value1,
                    callback: function($$v) {
                      _vm.$set(_vm.resultJson.notifyParty, "value1", $$v)
                    },
                    expression: "resultJson.notifyParty.value1"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c("td", { staticClass: "header", attrs: { rowspan: "7" } }, [
          _vm._v(_vm._s(_vm.$t("SeaExport.CargoSize")))
        ]),
        _c(
          "td",
          { attrs: { rowspan: "7" } },
          [
            _c(
              "el-form-item",
              [
                _c("el-input", {
                  attrs: { type: "textarea", resize: "none", rows: 11 },
                  on: {
                    focus: function($event) {
                      return _vm.handleFocus("goodSize")
                    }
                  },
                  model: {
                    value: _vm.resultJson.goodSize.value,
                    callback: function($$v) {
                      _vm.$set(_vm.resultJson.goodSize, "value", $$v)
                    },
                    expression: "resultJson.goodSize.value"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("tr", [
        _c(
          "td",
          [
            _c(
              "el-form-item",
              [
                _c("el-input", {
                  on: {
                    focus: function($event) {
                      return _vm.handleFocus("notifyParty")
                    }
                  },
                  model: {
                    value: _vm.resultJson.notifyParty.value2,
                    callback: function($$v) {
                      _vm.$set(_vm.resultJson.notifyParty, "value2", $$v)
                    },
                    expression: "resultJson.notifyParty.value2"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("tr", [
        _c(
          "td",
          [
            _c(
              "el-form-item",
              [
                _c("el-input", {
                  on: {
                    focus: function($event) {
                      return _vm.handleFocus("notifyParty")
                    }
                  },
                  model: {
                    value: _vm.resultJson.notifyParty.value3,
                    callback: function($$v) {
                      _vm.$set(_vm.resultJson.notifyParty, "value3", $$v)
                    },
                    expression: "resultJson.notifyParty.value3"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("tr", [
        _c(
          "td",
          [
            _c(
              "el-form-item",
              [
                _c("el-input", {
                  on: {
                    focus: function($event) {
                      return _vm.handleFocus("notifyParty")
                    }
                  },
                  model: {
                    value: _vm.resultJson.notifyParty.value4,
                    callback: function($$v) {
                      _vm.$set(_vm.resultJson.notifyParty, "value4", $$v)
                    },
                    expression: "resultJson.notifyParty.value4"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("tr", [
        _c(
          "td",
          [
            _c(
              "el-form-item",
              [
                _c("el-input", {
                  on: {
                    focus: function($event) {
                      return _vm.handleFocus("notifyParty")
                    }
                  },
                  model: {
                    value: _vm.resultJson.notifyParty.value5,
                    callback: function($$v) {
                      _vm.$set(_vm.resultJson.notifyParty, "value5", $$v)
                    },
                    expression: "resultJson.notifyParty.value5"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("tr", [
        _c(
          "td",
          [
            _c(
              "el-form-item",
              [
                _c("el-input", {
                  on: {
                    focus: function($event) {
                      return _vm.handleFocus("notifyParty")
                    }
                  },
                  model: {
                    value: _vm.resultJson.notifyParty.value6,
                    callback: function($$v) {
                      _vm.$set(_vm.resultJson.notifyParty, "value6", $$v)
                    },
                    expression: "resultJson.notifyParty.value6"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("tr", [
        _c(
          "td",
          [
            _c(
              "el-form-item",
              [
                _c("el-input", {
                  on: {
                    focus: function($event) {
                      return _vm.handleFocus("notifyParty")
                    }
                  },
                  model: {
                    value: _vm.resultJson.notifyParty.value7,
                    callback: function($$v) {
                      _vm.$set(_vm.resultJson.notifyParty, "value7", $$v)
                    },
                    expression: "resultJson.notifyParty.value7"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("tr", [
        _c("td", { staticClass: "header" }, [
          _vm._v(_vm._s(_vm.$t("Payment.portOfLoading")))
        ]),
        _c(
          "td",
          [
            _c(
              "el-form-item",
              [
                _c("el-input", {
                  on: {
                    focus: function($event) {
                      return _vm.handleFocus("portOfLoading")
                    }
                  },
                  model: {
                    value: _vm.resultJson.portOfLoading.value,
                    callback: function($$v) {
                      _vm.$set(_vm.resultJson.portOfLoading, "value", $$v)
                    },
                    expression: "resultJson.portOfLoading.value"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c("td", { staticClass: "header" }, [
          _vm._v(_vm._s(_vm.$t("Payment.portOfTransfer")))
        ]),
        _c(
          "td",
          [
            _c(
              "el-form-item",
              [
                _c("el-input", {
                  on: {
                    focus: function($event) {
                      return _vm.handleFocus("transitPort")
                    }
                  },
                  model: {
                    value: _vm.resultJson.transitPort.value,
                    callback: function($$v) {
                      _vm.$set(_vm.resultJson.transitPort, "value", $$v)
                    },
                    expression: "resultJson.transitPort.value"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("tr", [
        _c("td", { staticClass: "header" }, [
          _vm._v(_vm._s(_vm.$t("queryJob.dischargingPortCode")))
        ]),
        _c(
          "td",
          [
            _c(
              "el-form-item",
              [
                _c("el-input", {
                  on: {
                    focus: function($event) {
                      return _vm.handleFocus("portOfDischarge")
                    }
                  },
                  model: {
                    value: _vm.resultJson.portOfDischarge.value,
                    callback: function($$v) {
                      _vm.$set(_vm.resultJson.portOfDischarge, "value", $$v)
                    },
                    expression: "resultJson.portOfDischarge.value"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c("td", { staticClass: "header" }, [
          _vm._v(_vm._s(_vm.$t("queryJob.placeOfDelivery")))
        ]),
        _c(
          "td",
          [
            _c(
              "el-form-item",
              [
                _c("el-input", {
                  on: {
                    focus: function($event) {
                      return _vm.handleFocus("placeOfDelivery")
                    }
                  },
                  model: {
                    value: _vm.resultJson.placeOfDelivery.value,
                    callback: function($$v) {
                      _vm.$set(_vm.resultJson.placeOfDelivery, "value", $$v)
                    },
                    expression: "resultJson.placeOfDelivery.value"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("tr", [
        _c("td", { staticClass: "header" }, [
          _vm._v(_vm._s(_vm.$t("SeaExport.Quantity")))
        ]),
        _c(
          "td",
          [
            _c(
              "el-form-item",
              [
                _c("el-input", {
                  on: {
                    focus: function($event) {
                      return _vm.handleFocus("numberOfPieces")
                    }
                  },
                  model: {
                    value: _vm.resultJson.numberOfPieces.value,
                    callback: function($$v) {
                      _vm.$set(_vm.resultJson.numberOfPieces, "value", $$v)
                    },
                    expression: "resultJson.numberOfPieces.value"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c("td", { staticClass: "header" }, [
          _vm._v(_vm._s(_vm.$t("SeaExport.Package")))
        ]),
        _c(
          "td",
          [
            _c(
              "el-form-item",
              [
                _c("el-input", {
                  on: {
                    focus: function($event) {
                      return _vm.handleFocus("packing")
                    }
                  },
                  model: {
                    value: _vm.resultJson.packing.value,
                    callback: function($$v) {
                      _vm.$set(_vm.resultJson.packing, "value", $$v)
                    },
                    expression: "resultJson.packing.value"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("tr", [
        _c("td", { staticClass: "header" }, [
          _vm._v(_vm._s(_vm.$t("SeaExport.Weight")))
        ]),
        _c(
          "td",
          [
            _c(
              "el-form-item",
              [
                _c("el-input", {
                  on: {
                    focus: function($event) {
                      return _vm.handleFocus("grossWeight")
                    }
                  },
                  model: {
                    value: _vm.resultJson.grossWeight.value,
                    callback: function($$v) {
                      _vm.$set(_vm.resultJson.grossWeight, "value", $$v)
                    },
                    expression: "resultJson.grossWeight.value"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c("td", { staticClass: "header" }, [
          _vm._v(_vm._s(_vm.$t("SeaExport.Cubage")))
        ]),
        _c(
          "td",
          [
            _c(
              "el-form-item",
              [
                _c("el-input", {
                  on: {
                    focus: function($event) {
                      return _vm.handleFocus("volume")
                    }
                  },
                  model: {
                    value: _vm.resultJson.volume.value,
                    callback: function($$v) {
                      _vm.$set(_vm.resultJson.volume, "value", $$v)
                    },
                    expression: "resultJson.volume.value"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("tr", [
        _c("td", { staticClass: "header" }, [
          _vm._v(_vm._s(_vm.$t("SeaExport.Marks")))
        ]),
        _c(
          "td",
          [
            _c(
              "el-form-item",
              [
                _c("el-input", {
                  attrs: { type: "textarea", resize: "none", rows: 10 },
                  on: {
                    focus: function($event) {
                      return _vm.handleFocus("marks")
                    }
                  },
                  model: {
                    value: _vm.resultJson.marks.value,
                    callback: function($$v) {
                      _vm.$set(_vm.resultJson.marks, "value", $$v)
                    },
                    expression: "resultJson.marks.value"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c("td", { staticClass: "header" }, [
          _vm._v(_vm._s(_vm.$t("Pricing.Goods")))
        ]),
        _c(
          "td",
          [
            _c(
              "el-form-item",
              [
                _c("el-input", {
                  attrs: { type: "textarea", resize: "none", rows: 10 },
                  on: {
                    focus: function($event) {
                      return _vm.handleFocus("goodName")
                    }
                  },
                  model: {
                    value: _vm.resultJson.goodName.value,
                    callback: function($$v) {
                      _vm.$set(_vm.resultJson.goodName, "value", $$v)
                    },
                    expression: "resultJson.goodName.value"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("tr", [
        _c("td", { staticClass: "header" }, [
          _vm._v(_vm._s(_vm.$t("Payment.remarks")))
        ]),
        _c(
          "td",
          { attrs: { colspan: "3" } },
          [
            _c(
              "el-form-item",
              [
                _c("el-input", {
                  attrs: { type: "textarea", resize: "none", rows: 5 },
                  on: {
                    focus: function($event) {
                      return _vm.handleFocus("remarks")
                    }
                  },
                  model: {
                    value: _vm.resultJson.remarks.value,
                    callback: function($$v) {
                      _vm.$set(_vm.resultJson.remarks, "value", $$v)
                    },
                    expression: "resultJson.remarks.value"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }